module.exports = __webpack_public_path__ + "static/img/DaveLogo.fadb03b.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/DaveLogo.png
// module id = 560j
// module chunks = 1